import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './Header';

function NewFiling() {
  const [fiscalYear, setFiscalYear] = useState(new Date().getFullYear());
  const [townCode, setTownCode] = useState('');
  const [townName, setTownName] = useState('');
  const [formType, setFormType] = useState('');
  const [towns, setTowns] = useState([]);
  const [townSearch, setTownSearch] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [townIsActive, setTownIsActive] = useState(true);

  const currentYear = new Date().getFullYear();
  const yearOptions = [currentYear, currentYear - 1, currentYear - 2, currentYear - 3];

// eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/filings/towns`)
      .then(res => setTowns(res.data))
      .catch(err => console.error('Could not load towns', err));
  }, []);

  const filteredTowns = towns.filter(t =>
    t.town_name.toLowerCase().includes(townSearch.toLowerCase())
  );

  const handleSelectTown = (town) => {
  setTownCode(town.town_code);
  setTownName(town.town_name);
  setTownSearch(town.town_name);
  setTownIsActive(town.is_active);
  setShowDropdown(false);
};

  const handleSubmit = (e) => {
  e.preventDefault();
  if (!townCode) {
    alert('Please select a town from the list.');
    return;
  }
  if (!townIsActive) {
    alert('This town is not yet active on matownforms.com. Please contact your assessor\'s office.');
    return;
  }
  window.location.href = `/page1?fiscal_year=${fiscalYear}&town=${townName}&town_code=${townCode}&form_type=${formType}`;
};

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <Header />
        <h2 style={styles.subtitle}>Start a New Filing</h2>
        <form onSubmit={handleSubmit}>
          <div style={styles.field}>
            <label style={styles.label}>Fiscal Year</label>
            <select
              style={styles.input}
              value={fiscalYear}
              onChange={(e) => setFiscalYear(e.target.value)}
              required
            >
              {yearOptions.map((year) => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Massachusetts Town</label>
            <input
              style={styles.input}
              type="text"
              placeholder="Type to search towns..."
              value={townSearch}
              onChange={(e) => {
                setTownSearch(e.target.value);
                setTownCode('');
                setTownName('');
                setShowDropdown(true);
              }}
              onFocus={() => setShowDropdown(true)}
              autoComplete="off"
              required
            />
            {showDropdown && townSearch.length > 0 && filteredTowns.length > 0 && (
              <div style={styles.dropdown}>
                {filteredTowns.slice(0, 8).map((town) => (
                  <div
                    key={town.town_code}
                    style={styles.dropdownItem}
                    onClick={() => handleSelectTown(town)}
                  >
                    {town.town_name}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Type of Filing</label>
            <select
              style={styles.input}
              value={formType}
              onChange={(e) => setFormType(e.target.value)}
              required
            >
              <option value="">Select one...</option>
              <option value="form_2">Form 2 — Business Owner</option>
              <option value="form_2hf">Form 2HF — Second Home Owner</option>
            </select>
          </div>

          <button style={styles.button} type="submit">Continue</button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f4f6f9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    backgroundColor: '#ffffff',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '420px',
  },
  title: {
    color: '#1a3a5c',
    fontSize: '22px',
    marginBottom: '4px',
    textAlign: 'center',
  },
  subtitle: {
    color: '#444',
    fontSize: '18px',
    marginBottom: '24px',
    textAlign: 'center',
  },
  field: {
    marginBottom: '16px',
    position: 'relative',
  },
  label: {
    display: 'block',
    marginBottom: '6px',
    color: '#333',
    fontSize: '14px',
    fontWeight: '600',
  },
  input: {
    width: '100%',
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '14px',
    boxSizing: 'border-box',
  },
  dropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    borderRadius: '4px',
    zIndex: 100,
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  },
  dropdownItem: {
    padding: '10px 12px',
    fontSize: '14px',
    cursor: 'pointer',
    borderBottom: '1px solid #f0f0f0',
    color: '#333',
  },
  button: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#1a3a5c',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
    marginTop: '8px',
  },
};

export default NewFiling;